import * as React from 'react'

import { StyleSheet, View } from '@react-pdf/renderer'

interface HeaderProps {
	children?: any
}

export const Content: React.FC<HeaderProps> = ({ children }) => {
	return <View style={styles.content}>{children}</View>
}

const styles = StyleSheet.create({
	content: {
		width: '100%',
		minHeight: '120mm',
		marginBottom: '8mm',
		borderBottomWidth: '1px',
		borderBottomColor: '#ccc',
	},
})
